import React from 'react';
import {getUrlForPhoto} from '../../lib/cloudinary';
import ReactPhotoGallery from 'react-photo-gallery';
import {List, Map} from 'immutable';
import Photo from './Photo';
import styles from './styles.scss';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import {initMediaLibrary, openMediaLibrary} from './mediaLibrary';

const SortablePhoto = SortableElement(Photo);
const SortableGallery = SortableContainer(props => {
  return <ReactPhotoGallery {...props} ImageComponent={SortablePhoto} />;
});

export default class GalleryWidget extends React.Component {
  static initMediaLibrary = initMediaLibrary;

  static defaultProps = {
    value: List([]),
  };

  handleInsert = media => {
    const {onChange, value} = this.props;
    const list = List(media.map(m => Map(m)));
    onChange(uniqueList(list.concat(value)));
  };

  render() {
    const {forID, classNameWrapper} = this.props;

    const photos = this.props.value.toJS();

    return (
      <div id={forID} className={classNameWrapper}>
        <button onClick={this.handleClickNew} className={styles.addButton}>
          Add images
        </button>
        {photos.length > 0 && (
          <SortableGallery
            helperClass={styles.photoDrag}
            distance={10}
            axis="xy"
            direction="column"
            margin={2}
            columns={5}
            photos={photos.map(dataToPhoto)}
            onClick={this.handleRemove}
            onSortEnd={this.handleSortEnd}
          />
        )}
      </div>
    );
  }

  handleRemove = (event, data) => {
    const {onChange, value} = this.props;
    event.preventDefault();
    onChange(value.delete(data.index));
  };

  handleSortEnd = ({oldIndex, newIndex}) => {
    const {onChange, value} = this.props;
    if (oldIndex === newIndex) return;
    const newValue = value.delete(oldIndex).insert(newIndex, value.get(oldIndex));
    onChange(newValue);
  };

  handleClickNew = event => {
    event.preventDefault();
    openMediaLibrary(this.handleInsert);
  };
}

function uniqueList(list) {
  return list
    .groupBy(photo => photo.get('cloudinaryId'))
    .map(photo => photo.first())
    .toList();
}

function dataToPhoto(photo, index) {
  return {
    id: photo.cloudinaryId,
    key: index,
    src: getUrlForPhoto({id: photo.cloudinaryId, width: 250, height: 250}),
    width: 1, // photo.width,
    height: 1, // photo.height
    srcWidth: photo.width,
    srcHeight: photo.height,
  };
}
